const TEMP_CAPABILITY_OPTIONS = [
  {
    code: '8',
    desc: '活动推送'
  },
  {
    code: '9',
    desc: '三方支付'
  }
]

const LEGACY_CAPABILITY_CODES = ['0', '1']
const READONLY_CONTROL_CAPABILITY_CODES = ['5', '6']
const THIRD_PAY_CAPABILITY_CODE = '9'
const RECHARGE_TEMPLATE_CAPABILITY_CODE = '10'
const PAGE_ENTRY_SOURCE_TYPE = 1
const ENTRY_CONFIG_KEY_SEPARATOR = '__'

const clone = (value) => JSON.parse(JSON.stringify(value))

const ensureArray = (value) => (Array.isArray(value) ? value : [])

export const toCapabilityCode = (value) =>
  value === undefined || value === null || value === '' ? '' : String(value)

const createFixedSlots = () => Array.from({ length: 9 }, () => null)

const createPaymentPanel = () => ({
  countryIosGoodsIds: createFixedSlots(),
  countryAndroidGoodsIds: createFixedSlots(),
  defaultIosGoodsIds: createFixedSlots(),
  defaultAndroidGoodsIds: createFixedSlots()
})

const normalizeFixedArray = (value) =>
  Array.from({ length: 9 }, (_, index) => {
    const list = ensureArray(value)
    return list[index] === undefined ? null : list[index]
  })

const parseGroupParam = (value) => {
  if (!value) return {}
  if (typeof value === 'object') return value
  try {
    return JSON.parse(value)
  } catch (error) {
    return {}
  }
}

const createLegacyRollbackParam = () => ({
  episodeCharge: {
    chargeCoins: ''
  },
  activityAdLimit: {
    maxAdWatchCount: ''
  },
  dailyAdUnlockLimit: {
    maxAdWatchCount: ''
  },
  paymentPanel: createPaymentPanel(),
  iosExpanded: false,
  androidExpanded: false,
  iosDefaultExpanded: false,
  androidDefaultExpanded: false
})

const createPopupPushParam = () => ({
  enablePopupPush: true
})

const createPayLinkParam = () => ({
  payLinkType: 1
})

const createAdStrategyParam = () => ({
  signInAd: {
    enabled: false,
    priority: 'video',
    h5StayEnabled: true,
    h5StaySeconds: 15,
    dailyLimit: 1,
    adsPerReward: 1,
    rewardRules: [{ nth: 1, coinAmount: null }]
  },
  unlockAd: {
    enabled: false,
    priority: 'video',
    h5StayEnabled: true,
    h5StaySeconds: 15,
    payPanelFloat: false,
    adsPerUnlock: 1,
    episodesPerUnlock: 1,
    dailyUnlockLimit: 1
  },
  splashAd: {
    enabled: false,
    triggerTypes: ['cold']
  },
  feedAd: {
    enabled: false,
    positions: ['PLAY_PAGE']
  },
  interstitialAd: {
    enabled: false,
    triggerScenes: []
  }
})

const createActivityTaskParam = () => ({
  maxAdWatchCount: ''
})

const createPaymentPanelParam = () => ({
  ...createPaymentPanel(),
  iosExpanded: false,
  androidExpanded: false,
  iosDefaultExpanded: false,
  androidDefaultExpanded: false
})

const createEpisodePriceParam = () => ({
  chargeCoins: ''
})

const createUnlockLayerParam = () => ({
  uiStyle: '',
  priceText: ''
})

const createActivityPushParam = () => ({
  templateRuleId: null,
  templateRuleName: '',
  popupId: null,
  popupName: '',
  watchingDurationType: 0,
  durationMin: null,
  durationMax: null,
  position: null,
  triggerTiming: null,
  popupCount: 0,
  priority: 1
})

const createThirdPayRuleParam = () => ({
  entryConfigKeys: []
})

const createThirdPayDefaultPayMethod = () => ({
  payMethod: 0,
  provider: '',
  isDefault: true
})

const createThirdPayParam = () => ({
  iosRules: [createThirdPayRuleParam()],
  androidRules: [createThirdPayRuleParam()],
  iosPayMethods: [createThirdPayDefaultPayMethod()],
  androidPayMethods: [createThirdPayDefaultPayMethod()],
  iosPayLinkType: 0,
  androidPayLinkType: 0
})

let rechargePayRowId = 0
let rechargeGoodsRowId = 0

const createRechargeDefaultPayMethod = () => ({
  id: ++rechargePayRowId,
  payMethod: 0,
  provider: '',
  isDefault: true
})

const createRechargeGoodsSections = (supportsGold = true) =>
  supportsGold ? [{ key: 'subscription' }, { key: 'gold' }] : [{ key: 'subscription' }]

const createRechargePanel = (key, title, enabled, supportsGoods, supportsGold) => ({
  key,
  title,
  supportsGoods,
  supportsGold,
  thirdPay: enabled,
  payLinkType: 0,
  payMethods: [createRechargeDefaultPayMethod()],
  goodsSections: supportsGoods ? createRechargeGoodsSections(supportsGold) : [],
  subscriptionGoods: [],
  goldGoods: [],
  adTagGoodsId: null,
  adTagVisible: false,
  adTagPreviewGoodsId: null
})

const createRechargeTemplateParam = () => ({
  ios: {
    panels: [
      createRechargePanel('paywall', '付费墙', false, true, true),
      createRechargePanel('wallet', '钱包页', false, true, true),
      createRechargePanel('vip', 'VIP页', false, true, false)
    ],
    activity: {
      thirdPay: false,
      pushRuleIds: [],
      payMethods: [createRechargeDefaultPayMethod()]
    },
    discount: {
      thirdPay: false,
      payMethods: [createRechargeDefaultPayMethod()]
    }
  },
  android: {
    panels: [
      createRechargePanel('paywall', '付费墙', false, true, true),
      createRechargePanel('wallet', '钱包页', false, true, true),
      createRechargePanel('vip', 'VIP页', false, true, false)
    ],
    activity: {
      thirdPay: false,
      pushRuleIds: [],
      payMethods: [createRechargeDefaultPayMethod()]
    },
    discount: {
      thirdPay: false,
      payMethods: [createRechargeDefaultPayMethod()]
    }
  }
})

const normalizeEntrySourceType = (entrySourceType) => {
  const normalizedValue = Number(entrySourceType)
  return Number.isNaN(normalizedValue)
    ? PAGE_ENTRY_SOURCE_TYPE
    : normalizedValue
}

const buildThirdPayEntryConfigKey = (entrySourceType, entryId) =>
  `${normalizeEntrySourceType(
    entrySourceType
  )}${ENTRY_CONFIG_KEY_SEPARATOR}${
    entryId === null || entryId === undefined ? '' : String(entryId)
  }`

const parseThirdPayEntryConfigKey = (value) => {
  if (!value && value !== 0) return null
  const rawValue = String(value)
  if (!rawValue.includes(ENTRY_CONFIG_KEY_SEPARATOR)) {
    return {
      entrySourceType: PAGE_ENTRY_SOURCE_TYPE,
      entryId: rawValue
    }
  }

  const [entrySourceType, ...entryIdParts] = rawValue.split(
    ENTRY_CONFIG_KEY_SEPARATOR
  )
  if (!entryIdParts.length) return null

  return {
    entrySourceType: normalizeEntrySourceType(entrySourceType),
    entryId: entryIdParts.join(ENTRY_CONFIG_KEY_SEPARATOR)
  }
}

const normalizeThirdPayRuleParam = (rule = {}) => {
  if (Array.isArray(rule.entryConfigKeys)) {
    return {
      entryConfigKeys: rule.entryConfigKeys.map((item) => String(item))
    }
  }

  const entryConfigs =
    Array.isArray(rule.entryConfigs) && rule.entryConfigs.length
      ? rule.entryConfigs
      : (rule.entryPoints || []).map((entryPoint) => ({
          entrySourceType: PAGE_ENTRY_SOURCE_TYPE,
          entryId: String(entryPoint)
        }))

  return {
    entryConfigKeys: entryConfigs
      .map((item) =>
        buildThirdPayEntryConfigKey(item.entrySourceType, item.entryId)
      )
      .filter(Boolean)
  }
}

const normalizeThirdPayRules = (rules) =>
  Array.isArray(rules) && rules.length
    ? rules.map((item) => normalizeThirdPayRuleParam(item))
    : [createThirdPayRuleParam()]

const normalizeOptionalNumber = (value) => {
  return value === 0 || (value !== null && value !== undefined && value !== '')
    ? Number(value)
    : ''
}

const normalizeThirdPayMethods = (payMethods = []) => {
  if (!Array.isArray(payMethods) || !payMethods.length) {
    return [createThirdPayDefaultPayMethod()]
  }

  return payMethods.map((item) => ({
    payMethod: normalizeOptionalNumber(item.payMethod),
    provider:
      normalizeOptionalNumber(item.payMethod) === 0
        ? ''
        : normalizeOptionalNumber(item.provider),
    isDefault: !!item.isDefault
  }))
}

const buildThirdPayRulePayload = (rule = {}) => {
  const entryConfigs = (rule.entryConfigKeys || [])
    .map((item) => parseThirdPayEntryConfigKey(item))
    .filter(Boolean)
    .map((item) => ({
      entrySourceType: normalizeEntrySourceType(item.entrySourceType),
      entryId: String(item.entryId)
    }))

  return {
    entryConfigs,
    entryPoints: entryConfigs
      .map((item) => Number(item.entryId))
      .filter((item) => !Number.isNaN(item))
  }
}

const buildThirdPayMethodPayload = (payMethods = []) =>
  payMethods.map((item) => {
    const payload = {
      payMethod: Number(item.payMethod),
      isDefault: !!item.isDefault
    }

    if (item.payMethod !== 0 && (item.provider === 0 || item.provider !== '')) {
      payload.provider = Number(item.provider)
    }

    return payload
  })

const PRIORITY_FORM_TO_API = {
  video: 'PRIORITY_VIDEO',
  h5: 'PRIORITY_H5'
}

const PRIORITY_API_TO_FORM = {
  PRIORITY_VIDEO: 'video',
  PRIORITY_H5: 'h5'
}

const SPLASH_FORM_TO_API = {
  cold: 'COLD_START',
  hot: 'HOT_START'
}

const SPLASH_API_TO_FORM = {
  COLD_START: 'cold',
  HOT_START: 'hot'
}

const FEED_PLACEMENT_TO_FORM = {
  PLAY_PAGE: 'PLAY_PAGE',
  ACTIVITY_PAGE: 'ACTIVITY_PAGE',
  play: 'PLAY_PAGE',
  activity: 'ACTIVITY_PAGE'
}

const FEED_PLACEMENT_TO_API = {
  PLAY_PAGE: 'PLAY_PAGE',
  ACTIVITY_PAGE: 'ACTIVITY_PAGE',
  play: 'PLAY_PAGE',
  activity: 'ACTIVITY_PAGE'
}

const normalizePositiveNumber = (value, fallback) => {
  const nextValue = Number(value)
  if (Number.isFinite(nextValue) && nextValue > 0) {
    return nextValue
  }
  return fallback
}

const mapRewardRulesToForm = (rules, fallbackRules) => {
  if (!Array.isArray(rules) || !rules.length) return clone(fallbackRules)
  return rules.map((item, index) => ({
    nth: normalizePositiveNumber(
      item && (item.rangeStart || item.nth),
      index + 1
    ),
    coinAmount: normalizePositiveNumber(
      item && (item.coin || item.coinAmount),
      fallbackRules[0].coinAmount
    )
  }))
}

const buildRewardRulesPayload = (rules, dailyLimit) => {
  if (!Array.isArray(rules) || !rules.length) return []

  const total = normalizePositiveNumber(dailyLimit, rules.length)
  const normalizedRules = rules.slice(0, total)

  return normalizedRules.map((item, index) => {
    const rangeStart = index + 1
    const isLast = index === normalizedRules.length - 1
    const rangeEnd =
      isLast && normalizedRules.length < total ? total : rangeStart

    return {
      rangeStart,
      rangeEnd,
      coin: normalizePositiveNumber(item && item.coinAmount, 1)
    }
  })
}

const parseH5RewardConditions = (conditions, baseConfig) => {
  const nextConfig = {
    ...baseConfig,
    h5StayEnabled: true
  }

  if (!Array.isArray(conditions)) return nextConfig

  conditions.forEach((item) => {
    if (!item) return
    if (item.conditionType === 'DURATION') {
      nextConfig.h5StayEnabled = true
      nextConfig.h5StaySeconds = normalizePositiveNumber(
        item.conditionValue,
        baseConfig.h5StaySeconds
      )
    }
  })

  return nextConfig
}

const buildH5RewardConditionsPayload = (config) => [
  {
    conditionType: 'DURATION',
    conditionValue: normalizePositiveNumber(config.h5StaySeconds, 1)
  }
]

const mapSignInConfigToForm = (config, baseConfig) => {
  const source = config || {}
  const nextConfig = parseH5RewardConditions(
    source.h5RewardConditions,
    baseConfig
  )

  return {
    ...nextConfig,
    priority:
      PRIORITY_API_TO_FORM[source.adSourcePriority] || baseConfig.priority,
    dailyLimit: normalizePositiveNumber(
      source.dailyLimit,
      baseConfig.dailyLimit
    ),
    adsPerReward: normalizePositiveNumber(
      source.adsPerReward,
      baseConfig.adsPerReward
    ),
    rewardRules: mapRewardRulesToForm(
      source.rewardRules,
      baseConfig.rewardRules
    )
  }
}

const buildSignInConfigPayload = (config = {}) => ({
  adSourcePriority:
    PRIORITY_FORM_TO_API[config.priority] || PRIORITY_FORM_TO_API.video,
  adsPerReward: normalizePositiveNumber(config.adsPerReward, 1),
  dailyLimit: normalizePositiveNumber(config.dailyLimit, 1),
  h5RewardConditions: buildH5RewardConditionsPayload(config),
  rewardRules: buildRewardRulesPayload(config.rewardRules, config.dailyLimit)
})

const mapUnlockConfigToForm = (config, baseConfig) => {
  const source = config || {}
  const nextConfig = parseH5RewardConditions(
    source.h5RewardConditions,
    baseConfig
  )

  return {
    ...nextConfig,
    priority:
      PRIORITY_API_TO_FORM[source.adSourcePriority] || baseConfig.priority,
    payPanelFloat: Boolean(source.paywallFloatEnabled),
    adsPerUnlock: normalizePositiveNumber(
      source.adsRequired,
      baseConfig.adsPerUnlock
    ),
    episodesPerUnlock: normalizePositiveNumber(
      source.episodesUnlocked,
      baseConfig.episodesPerUnlock
    ),
    dailyUnlockLimit: normalizePositiveNumber(
      source.dailyLimit,
      baseConfig.dailyUnlockLimit
    )
  }
}

const buildUnlockConfigPayload = (config = {}) => ({
  adSourcePriority:
    PRIORITY_FORM_TO_API[config.priority] || PRIORITY_FORM_TO_API.video,
  adsRequired: normalizePositiveNumber(config.adsPerUnlock, 1),
  dailyLimit: normalizePositiveNumber(config.dailyUnlockLimit, 1),
  episodesUnlocked: normalizePositiveNumber(config.episodesPerUnlock, 1),
  h5RewardConditions: buildH5RewardConditionsPayload(config),
  paywallFloatEnabled: Boolean(config.payPanelFloat)
})

const mapSplashConfigToForm = (config, baseConfig) => {
  const triggerScenarios = Array.isArray(config && config.triggerScenarios)
    ? config.triggerScenarios
        .map((item) => SPLASH_API_TO_FORM[item] || item)
        .filter(Boolean)
    : []

  return {
    ...baseConfig,
    triggerTypes: triggerScenarios.length
      ? triggerScenarios
      : clone(baseConfig.triggerTypes)
  }
}

const buildSplashConfigPayload = (config = {}) => ({
  triggerScenarios: (config.triggerTypes || [])
    .map((item) => SPLASH_FORM_TO_API[item] || item)
    .filter(Boolean)
})

const mapFeedConfigToForm = (config, baseConfig) => {
  const positions = Array.isArray(config)
    ? config
    : Array.isArray(config && config.adPlacements)
    ? config.adPlacements
    : Array.isArray(config && config.positions)
    ? config.positions
    : []
  const normalizedPositions = positions
    .map((item) => FEED_PLACEMENT_TO_FORM[item] || item)
    .filter(Boolean)

  return {
    ...baseConfig,
    positions: normalizedPositions.length
      ? [...normalizedPositions]
      : clone(baseConfig.positions)
  }
}

const buildFeedConfigPayload = (config = {}) => ({
  adPlacements: Array.isArray(config.positions)
    ? config.positions
        .map((item) => FEED_PLACEMENT_TO_API[item] || item)
        .filter(Boolean)
    : []
})

const isSignInRuntimeShape = (config) =>
  Boolean(
    config &&
      (config.priority !== undefined ||
        config.h5StayEnabled !== undefined ||
        config.rewardRules !== undefined)
  )

const isUnlockRuntimeShape = (config) =>
  Boolean(
    config &&
      (config.priority !== undefined ||
        config.h5StayEnabled !== undefined ||
        config.payPanelFloat !== undefined)
  )

const isSplashRuntimeShape = (config) =>
  Boolean(config && config.triggerTypes !== undefined)

const isFeedRuntimeShape = (config) =>
  Boolean(config && config.positions !== undefined)

const INTERSTITIAL_SCENARIO_TO_FORM = {
  BACK_HOME: 'BACK_HOME',
  ACTIVITY_PAGE: 'ACTIVITY_PAGE',
  CLAIM_REWARD: 'CLAIM_REWARD'
}

const INTERSTITIAL_SCENARIO_TO_API = {
  BACK_HOME: 'BACK_HOME',
  ACTIVITY_PAGE: 'ACTIVITY_PAGE',
  CLAIM_REWARD: 'CLAIM_REWARD'
}

const mapInterstitialConfigToForm = (config, baseConfig) => {
  const triggerScenes = Array.isArray(config && config.triggerScenes)
    ? config.triggerScenes
        .map((item) => INTERSTITIAL_SCENARIO_TO_FORM[item] || item)
        .filter(Boolean)
    : []

  return {
    ...baseConfig,
    triggerScenes: triggerScenes.length
      ? [...triggerScenes]
      : clone(baseConfig.triggerScenes)
  }
}

const buildInterstitialConfigPayload = (config = {}) => ({
  triggerScenes: (config.triggerScenes || [])
    .map((item) => INTERSTITIAL_SCENARIO_TO_API[item] || item)
    .filter(Boolean)
})

const isInterstitialRuntimeShape = (config) =>
  Boolean(config && config.triggerScenes !== undefined)

export const isLegacyCapability = (code) =>
  LEGACY_CAPABILITY_CODES.includes(toCapabilityCode(code))

export const isReadonlyControlGroupCapability = (code) =>
  READONLY_CONTROL_CAPABILITY_CODES.includes(toCapabilityCode(code))

export const isThirdPayCapability = (code) =>
  toCapabilityCode(code) === THIRD_PAY_CAPABILITY_CODE

export const isRechargeTemplateCapability = (code) =>
  toCapabilityCode(code) === RECHARGE_TEMPLATE_CAPABILITY_CODE

export const normalizeCapabilityOptions = (list = []) => {
  const normalized = Array.isArray(list)
    ? list.map((item) => ({
        ...item,
        code: String(item.code)
      }))
    : []

  return TEMP_CAPABILITY_OPTIONS.reduce((acc, item) => {
    if (acc.some((current) => String(current.code) === item.code)) {
      return acc
    }
    return acc.concat(item)
  }, normalized)
}

export const appendCapabilityOption = (list = [], code, desc) => {
  const nextCode = toCapabilityCode(code)
  if (!nextCode) return list
  if (list.some((item) => String(item.code) === nextCode)) return list

  const tempItem = TEMP_CAPABILITY_OPTIONS.find(
    (item) => item.code === nextCode
  )
  return list.concat({
    code: nextCode,
    desc: desc || (tempItem && tempItem.desc) || nextCode
  })
}

export const getCapabilityDesc = (list = [], code) => {
  const nextCode = toCapabilityCode(code)
  const item = list.find((current) => String(current.code) === nextCode)
  if (item) return item.desc
  const tempItem = TEMP_CAPABILITY_OPTIONS.find(
    (current) => current.code === nextCode
  )
  return tempItem ? tempItem.desc : nextCode
}

export const createExperimentForm = () => ({
  id: '',
  experimentName: '',
  experimentUserNum: 10000,
  experimentCapability: '',
  experimentType: '',
  deviceSys: '',
  countriesUnlimited: '',
  countries: [],
  linkChannel: [],
  playIdsUnlimited: '',
  playIds: [],
  crowdMode: 'all',
  crowdType: -1,
  crowdIds: [],
  crowdCountryCodes: [],
  crowdOptions: [],
  controlGroupId: '',
  controlGroupName: '对照组',
  controlGroupParticipateRatio: 0,
  groups: [],
  controlGroupParam: {}
})

export const isEditableControlCapability = (code) => {
  const capabilityCode = toCapabilityCode(code)
  return Boolean(capabilityCode) && !isLegacyCapability(capabilityCode)
}

const getControlGroupRecord = (data = {}) => {
  const groupList = Array.isArray(data.groups) ? data.groups : []
  const capabilityCode = toCapabilityCode(data.experimentCapability)

  if (isLegacyCapability(capabilityCode)) {
    return groupList[0] || null
  }

  return (
    groupList.find((item) => Number(item.experimentGroupTag) === 1) ||
    groupList[0] ||
    null
  )
}

const getExperimentGroupRecords = (data = {}) => {
  const groupList = Array.isArray(data.groups) ? data.groups : []
  const capabilityCode = toCapabilityCode(data.experimentCapability)

  if (isLegacyCapability(capabilityCode)) {
    return groupList.slice(1)
  }

  return groupList.filter((item) => Number(item.experimentGroupTag) !== 1)
}

export const createGroupParamByCapability = (code) => {
  const capabilityCode = toCapabilityCode(code)
  switch (capabilityCode) {
    case '0':
      return createLegacyRollbackParam()
    case '1':
      return createPopupPushParam()
    case '2':
      return createPayLinkParam()
    case '3':
      return createAdStrategyParam()
    case '4':
      return createActivityTaskParam()
    case '5':
      return createPaymentPanelParam()
    case '6':
      return createEpisodePriceParam()
    case '7':
      return createUnlockLayerParam()
    case '8':
      return createActivityPushParam()
    case '9':
      return createThirdPayParam()
    case '10':
      return createRechargeTemplateParam()
    default:
      return {}
  }
}

const RECHARGE_PANEL_ENTRY_MAP = {
  paywall: 0,
  wallet: 1,
  vip: 2
}

const RECHARGE_DISCOUNT_ENTRY_ID = 3
const RECHARGE_ACTIVITY_ENTRY_ID = 4

const normalizeRechargeOptionalNumber = (value) =>
  value === 0 || (value !== null && value !== undefined && value !== '')
    ? Number(value)
    : ''

const normalizeRechargeGoodsId = (value) => {
  if (value === 0 || value === '0') return 0
  if (value === null || value === undefined || value === '') return null
  const numberValue = Number(value)
  return Number.isNaN(numberValue) ? value : numberValue
}

const normalizeRechargePayMethodsFromBackend = (payMethods = []) => {
  const list = Array.isArray(payMethods) && payMethods.length
    ? [...payMethods].sort((a, b) => Number(a.sortOrder || 0) - Number(b.sortOrder || 0))
    : [createRechargeDefaultPayMethod()]
  const normalized = list.map((item) => {
    const payMethod = normalizeRechargeOptionalNumber(item.payMethod)
    return {
      id: ++rechargePayRowId,
      payMethod,
      provider: payMethod === 0 ? '' : normalizeRechargeOptionalNumber(item.provider),
      isDefault: !!item.isDefault,
      sortOrder: item.sortOrder
    }
  })
  if (!normalized.some((item) => item.isDefault) && normalized.length) {
    normalized[0].isDefault = true
  }
  return normalized
}

const normalizeRechargeSubscriptionGoodsFromBackend = (list = []) => {
  const source = Array.isArray(list) ? list : []
  return source.map((item) => ({
    id: ++rechargeGoodsRowId,
    goodsType: Number(item.goodsType) === 2 ? 2 : 1,
    goodsId: normalizeRechargeGoodsId(item.goodsId || item.id),
    onlyThird: !!(item.onlyThirdParty || item.onlyThird),
    defaultPayMethod: normalizeRechargeOptionalNumber(item.defaultPayMethod),
    defaultProvider: normalizeRechargeOptionalNumber(item.defaultProvider),
    visible: false,
    previewGoodsId: normalizeRechargeGoodsId(item.previewGoodsId || item.goodsId)
  }))
}

const normalizeRechargeGoldGoodsFromBackend = (list = []) => {
  const source = Array.isArray(list) ? list : []
  return source.map((item) => ({
    id: ++rechargeGoodsRowId,
    goodsType: 0,
    goodsId: normalizeRechargeGoodsId(item.goodsId || (item.isLocal ? null : item.id)),
    visible: false,
    previewGoodsId: normalizeRechargeGoodsId(item.previewGoodsId || item.goodsId)
  }))
}

const normalizeRechargeGoodsSectionsFromBackend = (sections, supportsGold = true) => {
  const supportedKeys = supportsGold ? ['subscription', 'gold'] : ['subscription']
  const normalized = []
  const appendKey = (key) => {
    if (supportedKeys.indexOf(key) === -1) return
    if (normalized.some((item) => item.key === key)) return
    normalized.push({ key })
  }
  if (Array.isArray(sections)) {
    sections.forEach((section) => {
      appendKey(typeof section === 'string' ? section : section && section.key)
    })
  }
  supportedKeys.forEach(appendKey)
  return normalized
}

const normalizeRechargePanelFromBackend = (source = {}, fallback = {}) => {
  const supportsGoods =
    source.supportsGoods !== undefined ? !!source.supportsGoods : !!fallback.supportsGoods
  const supportsGold =
    source.supportsGold !== undefined ? !!source.supportsGold : !!fallback.supportsGold
  return {
    key: source.key || fallback.key,
    title: source.title || fallback.title,
    supportsGoods,
    supportsGold,
    thirdPay: source.thirdPay !== undefined ? !!source.thirdPay : !!fallback.thirdPay,
    payLinkType: Number(source.payLinkType || 0),
    payMethods: normalizeRechargePayMethodsFromBackend(source.payMethods || fallback.payMethods),
    goodsSections: supportsGoods
      ? normalizeRechargeGoodsSectionsFromBackend(source.goodsSections || fallback.goodsSections, supportsGold)
      : [],
    subscriptionGoods: supportsGoods
      ? normalizeRechargeSubscriptionGoodsFromBackend(source.subscriptionGoods || fallback.subscriptionGoods)
      : [],
    goldGoods: supportsGold
      ? normalizeRechargeGoldGoodsFromBackend(source.goldGoods || fallback.goldGoods)
      : [],
    adTagGoodsId: normalizeRechargeGoodsId(
      source.adTagGoodsId !== undefined ? source.adTagGoodsId : source.adUnlockSubscribeItem
    ),
    adTagVisible: false,
    adTagPreviewGoodsId: normalizeRechargeGoodsId(
      source.adTagPreviewGoodsId || source.adTagGoodsId || source.adUnlockSubscribeItem
    )
  }
}

const normalizeRechargePlatformFromBackend = (source = {}, basePlatform = {}) => {
  const basePanels = basePlatform.panels || []
  const sourcePanels = Array.isArray(source.panels) ? source.panels : []
  return {
    panels: basePanels.map((panel) => {
      const sourcePanel = sourcePanels.find((item) => item.key === panel.key)
      return normalizeRechargePanelFromBackend(sourcePanel, panel)
    }),
    activity: {
      ...basePlatform.activity,
      ...(source.activity || {}),
      pushRuleIds: (source.activity && source.activity.pushRuleIds) || basePlatform.activity.pushRuleIds || [],
      payMethods: normalizeRechargePayMethodsFromBackend(
        (source.activity && source.activity.payMethods) || basePlatform.activity.payMethods
      )
    },
    discount: {
      ...basePlatform.discount,
      ...(source.discount || {}),
      payMethods: normalizeRechargePayMethodsFromBackend(
        (source.discount && source.discount.payMethods) || basePlatform.discount.payMethods
      )
    }
  }
}

const normalizeRechargeTemplateFromBackend = (param, base) => {
  if (param.iosRules || param.androidRules) {
    const convertRulesToPlatform = (rules = [], basePlatform) => {
      const rulesArray = Array.isArray(rules) ? rules : []
      const entryMap = {}
      rulesArray.forEach((rule) => {
        entryMap[rule.entryId] = rule
      })

      const defaultPanels = basePlatform.panels || []
      const panels = defaultPanels.map((panel) => {
        const entryId = RECHARGE_PANEL_ENTRY_MAP[panel.key]
        const rule = entryMap[entryId]
        if (!rule) return panel

        const payItems = Array.isArray(rule.payItems) ? rule.payItems : []
        const subscriptionGoods = payItems.filter((item) => Number(item.goodsType) !== 0)
        // 金币付费项可能来自 coinsList 字段，或者 payItems 中 goodsType === 0 的项
        const coinsListGoldGoods = Array.isArray(rule.coinsList) ? rule.coinsList : []
        const payItemsGoldGoods = payItems.filter((item) => Number(item.goodsType) === 0)
        const goldGoods = coinsListGoldGoods.length > 0 ? coinsListGoldGoods : payItemsGoldGoods
        const goodsSections = []
        if (subscriptionGoods.length) goodsSections.push({ key: 'subscription' })
        if (goldGoods.length) goodsSections.push({ key: 'gold' })

        return {
          key: panel.key,
          title: panel.title,
          supportsGoods: panel.supportsGoods,
          supportsGold: panel.supportsGold,
          thirdPay: !!rule.switchOn,
          payLinkType: Number(rule.payLinkType || 0),
          payMethods: normalizeRechargePayMethodsFromBackend(rule.payMethods || panel.payMethods),
          goodsSections: goodsSections.length ? goodsSections : panel.goodsSections,
          subscriptionGoods: normalizeRechargeSubscriptionGoodsFromBackend(subscriptionGoods),
          goldGoods: normalizeRechargeGoldGoodsFromBackend(goldGoods),
          adTagGoodsId: rule.adUnlockItem ? normalizeRechargeGoodsId(rule.adUnlockItem.goodsId) : null,
          adTagVisible: !!rule.adUnlockItem,
          adTagPreviewGoodsId: rule.adUnlockItem ? normalizeRechargeGoodsId(rule.adUnlockItem.goodsId) : null
        }
      })

      const activityRule = entryMap[RECHARGE_ACTIVITY_ENTRY_ID]
      const activity = {
        ...basePlatform.activity,
        thirdPay: activityRule ? !!activityRule.switchOn : basePlatform.activity.thirdPay,
        payLinkType: activityRule ? Number(activityRule.payLinkType || 0) : basePlatform.activity.payLinkType,
        payMethods: normalizeRechargePayMethodsFromBackend(
          activityRule ? activityRule.payMethods : basePlatform.activity.payMethods
        ),
        pushRuleIds: activityRule ? (activityRule.pushRuleIds || []) : basePlatform.activity.pushRuleIds
      }

      const discountRule = entryMap[RECHARGE_DISCOUNT_ENTRY_ID]
      const discount = {
        ...basePlatform.discount,
        thirdPay: discountRule ? !!discountRule.switchOn : basePlatform.discount.thirdPay,
        payLinkType: discountRule ? Number(discountRule.payLinkType || 0) : basePlatform.discount.payLinkType,
        payMethods: normalizeRechargePayMethodsFromBackend(
          discountRule ? discountRule.payMethods : basePlatform.discount.payMethods
        )
      }

      return { panels, activity, discount }
    }

    return {
      ios: convertRulesToPlatform(param.iosRules, base.ios),
      android: convertRulesToPlatform(param.androidRules, base.android)
    }
  }

  return {
    ios: normalizeRechargePlatformFromBackend(param.ios || {}, base.ios),
    android: normalizeRechargePlatformFromBackend(param.android || {}, base.android)
  }
}

export const normalizeGroupParamByCapability = (code, rawParam) => {
  const capabilityCode = toCapabilityCode(code)
  const base = createGroupParamByCapability(capabilityCode)
  const param = rawParam || {}

  switch (capabilityCode) {
    case '0':
      return {
        ...base,
        ...param,
        episodeCharge: {
          ...base.episodeCharge,
          ...(param.episodeCharge || {})
        },
        activityAdLimit: {
          ...base.activityAdLimit,
          ...(param.activityAdLimit || {})
        },
        dailyAdUnlockLimit: {
          ...base.dailyAdUnlockLimit,
          ...(param.dailyAdUnlockLimit || {})
        },
        paymentPanel: {
          ...base.paymentPanel,
          ...(param.paymentPanel || {}),
          countryIosGoodsIds: normalizeFixedArray(
            param.paymentPanel && param.paymentPanel.countryIosGoodsIds
          ),
          countryAndroidGoodsIds: normalizeFixedArray(
            param.paymentPanel && param.paymentPanel.countryAndroidGoodsIds
          ),
          defaultIosGoodsIds: normalizeFixedArray(
            param.paymentPanel && param.paymentPanel.defaultIosGoodsIds
          ),
          defaultAndroidGoodsIds: normalizeFixedArray(
            param.paymentPanel && param.paymentPanel.defaultAndroidGoodsIds
          )
        }
      }
    case '1':
    case '2':
      return {
        ...base,
        ...param
      }
    case '3':
      const signInFormConfig = param.signInConfig
        ? mapSignInConfigToForm(param.signInConfig, base.signInAd)
        : isSignInRuntimeShape(param.signInAd)
        ? param.signInAd
        : mapSignInConfigToForm(param.signInAd, base.signInAd)
      const unlockFormConfig = param.episodeUnlockConfig
        ? mapUnlockConfigToForm(param.episodeUnlockConfig, base.unlockAd)
        : isUnlockRuntimeShape(param.unlockAd)
        ? param.unlockAd
        : mapUnlockConfigToForm(param.unlockAd, base.unlockAd)
      const splashFormConfig = param.splashAdConfig
        ? mapSplashConfigToForm(param.splashAdConfig, base.splashAd)
        : isSplashRuntimeShape(param.splashAd)
        ? param.splashAd
        : mapSplashConfigToForm(param.splashAd, base.splashAd)
      const feedFormConfig = param.feedAdConfig
        ? mapFeedConfigToForm(param.feedAdConfig, base.feedAd)
        : isFeedRuntimeShape(param.feedAd)
        ? param.feedAd
        : mapFeedConfigToForm(param.feedAd, base.feedAd)
      const interstitialFormConfig = param.interstitialAdConfig
        ? mapInterstitialConfigToForm(param.interstitialAdConfig, base.interstitialAd)
        : isInterstitialRuntimeShape(param.interstitialAd)
        ? param.interstitialAd
        : mapInterstitialConfigToForm(param.interstitialAd, base.interstitialAd)
      return {
        ...base,
        signInAd: {
          ...base.signInAd,
          ...signInFormConfig,
          enabled: Boolean(
            param.signInAdEnabled !== undefined
              ? param.signInAdEnabled
              : param.signInAd && param.signInAd.enabled
          )
        },
        unlockAd: {
          ...base.unlockAd,
          ...unlockFormConfig,
          enabled: Boolean(
            param.episodeUnlockAdEnabled !== undefined
              ? param.episodeUnlockAdEnabled
              : param.unlockAd && param.unlockAd.enabled
          )
        },
        splashAd: {
          ...base.splashAd,
          ...splashFormConfig,
          enabled: Boolean(
            param.splashAdEnabled !== undefined
              ? param.splashAdEnabled
              : param.splashAd && param.splashAd.enabled
          )
        },
        feedAd: {
          ...base.feedAd,
          ...feedFormConfig,
          enabled: Boolean(
            param.feedAdEnabled !== undefined
              ? param.feedAdEnabled
              : param.feedAd && param.feedAd.enabled
          )
        },
        interstitialAd: {
          ...base.interstitialAd,
          ...interstitialFormConfig,
          enabled: Boolean(
            param.interstitialAdEnabled !== undefined
              ? param.interstitialAdEnabled
              : param.interstitialAd && param.interstitialAd.enabled
          )
        }
      }
    case '4':
      return {
        maxAdWatchCount:
          param.maxAdWatchCount !== undefined
            ? param.maxAdWatchCount
            : param.activityAdLimit &&
              param.activityAdLimit.maxAdWatchCount !== undefined
            ? param.activityAdLimit.maxAdWatchCount
            : base.maxAdWatchCount
      }
    case '5':
      const {
        countryIosGoodsIds,
        countryAndroidGoodsIds,
        defaultIosGoodsIds,
        defaultAndroidGoodsIds,
        paymentPanel,
        ...rest
      } = param

      return {
        ...base,
        ...rest,
        countryIosGoodsIds: normalizeFixedArray(
          (paymentPanel && paymentPanel.countryIosGoodsIds) ||
            countryIosGoodsIds
        ),
        countryAndroidGoodsIds: normalizeFixedArray(
          (paymentPanel && paymentPanel.countryAndroidGoodsIds) ||
            countryAndroidGoodsIds
        ),
        defaultIosGoodsIds: normalizeFixedArray(
          (paymentPanel && paymentPanel.defaultIosGoodsIds) ||
            defaultIosGoodsIds
        ),
        defaultAndroidGoodsIds: normalizeFixedArray(
          (paymentPanel && paymentPanel.defaultAndroidGoodsIds) ||
            defaultAndroidGoodsIds
        )
      }
    case '6':
      return {
        chargeCoins:
          param.chargeCoins !== undefined
            ? param.chargeCoins
            : param.episodeCharge &&
              param.episodeCharge.chargeCoins !== undefined
            ? param.episodeCharge.chargeCoins
            : base.chargeCoins
      }
    case '7':
      return {
        ...base,
        uiStyle: param.uiStyle || param.memberUiStyle || '',
        priceText: param.priceText || param.memberPriceText || ''
      }
    case '8':
      return {
        ...base,
        ...param,
        watchingDurationType:
          param.watchingDurationType === undefined ||
          param.watchingDurationType === null
            ? base.watchingDurationType
            : Number(param.watchingDurationType),
        position:
          param.position === undefined || param.position === null
            ? null
            : Number(param.position),
        triggerTiming:
          param.triggerTiming === undefined || param.triggerTiming === null
            ? null
            : Number(param.triggerTiming),
        popupCount:
          param.popupCount === undefined || param.popupCount === null
            ? base.popupCount
            : Number(param.popupCount),
        priority:
          param.priority === undefined || param.priority === null
            ? base.priority
            : Number(param.priority)
      }
    case '9':
      return {
        ...base,
        ...param,
        iosRules: normalizeThirdPayRules(param.iosRules),
        androidRules: normalizeThirdPayRules(param.androidRules),
        iosPayMethods: normalizeThirdPayMethods(param.iosPayMethods),
        androidPayMethods: normalizeThirdPayMethods(param.androidPayMethods),
        iosPayLinkType:
          param.iosPayLinkType === undefined || param.iosPayLinkType === null
            ? base.iosPayLinkType
            : Number(param.iosPayLinkType),
        androidPayLinkType:
          param.androidPayLinkType === undefined ||
          param.androidPayLinkType === null
            ? base.androidPayLinkType
            : Number(param.androidPayLinkType)
      }
    case '10':
      return normalizeRechargeTemplateFromBackend(param, base)
    default:
      return param
  }
}

const RECHARGE_PAY_METHOD_NAME_MAP = {
  0: '内购',
  1: '卡支付',
  2: 'Apple Pay',
  3: 'Google Pay',
  4: '钱包'
}

const RECHARGE_PROVIDER_NAME_MAP = {
  0: 'Stripe',
  1: 'Antom',
  2: 'PayPal'
}

const buildRechargePayMethodsPayload = (payMethods = []) =>
  payMethods.map((item, index) => {
    const payMethod = Number(item.payMethod)
    const hasProvider = item.payMethod !== 0 && (item.provider === 0 || item.provider !== '')
    const provider = hasProvider ? Number(item.provider) : null
    return {
      payMethod,
      payMethodName: RECHARGE_PAY_METHOD_NAME_MAP[payMethod] || '',
      isDefault: !!item.isDefault,
      provider,
      providerName: provider !== null ? (RECHARGE_PROVIDER_NAME_MAP[provider] || '未知') : '未知',
      sortOrder: item.sortOrder !== undefined ? Number(item.sortOrder) : index
    }
  })

const buildRechargePayItemPayload = (item, index) => {
  const goodsType = (item.goodsType !== '' && item.goodsType !== null && item.goodsType !== undefined)
    ? Number(item.goodsType)
    : 1
  const payMethod = item.defaultPayMethod !== '' && item.defaultPayMethod !== null && item.defaultPayMethod !== undefined
    ? Number(item.defaultPayMethod)
    : null
  const provider = item.defaultProvider !== '' && item.defaultProvider !== null && item.defaultProvider !== undefined
    ? Number(item.defaultProvider)
    : null
  return {
    defaultPayMethod: payMethod,
    defaultPayMethodName: payMethod !== null ? (RECHARGE_PAY_METHOD_NAME_MAP[payMethod] || null) : null,
    defaultProvider: provider,
    defaultProviderName: provider !== null ? (RECHARGE_PROVIDER_NAME_MAP[provider] || null) : null,
    goodsId: normalizeRechargeGoodsId(item.goodsId),
    goodsName: null,
    goodsType,
    onlyThirdParty: goodsType === 0 ? false : !!item.onlyThird,
    sortOrder: index
  }
}

const buildRechargePayItemsPayload = (subscriptionGoods = [], goldGoods = []) => {
  const items = [
    ...subscriptionGoods.map((item, index) => buildRechargePayItemPayload(item, index)),
    ...goldGoods.map((item, index) =>
      buildRechargePayItemPayload(
        { ...item, goodsType: 0 },
        subscriptionGoods.length + index
      )
    )
  ]
  return items
}

const buildRechargePlatformRules = (platform = {}) => {
  const rules = []
  const panels = Array.isArray(platform.panels) ? platform.panels : []

  panels.forEach((panel) => {
    const entryId = RECHARGE_PANEL_ENTRY_MAP[panel.key]
    if (entryId === undefined) return

    const rule = {
      entryId,
      switchOn: !!panel.thirdPay,
      payLinkType: Number(panel.payLinkType || 0),
      payMethods: buildRechargePayMethodsPayload(panel.payMethods || []),
      payItems: buildRechargePayItemsPayload(
        panel.subscriptionGoods || [],
        panel.goldGoods || []
      )
    }

    if (panel.adTagGoodsId !== null && panel.adTagGoodsId !== undefined && panel.adTagGoodsId !== '') {
      rule.adUnlockItem = { goodsId: normalizeRechargeGoodsId(panel.adTagGoodsId) }
    }

    rules.push(rule)
  })

  if (platform.discount) {
    rules.push({
      entryId: RECHARGE_DISCOUNT_ENTRY_ID,
      switchOn: !!platform.discount.thirdPay,
      payLinkType: Number(platform.discount.payLinkType || 0),
      payMethods: buildRechargePayMethodsPayload(platform.discount.payMethods || [])
    })
  }

  if (platform.activity) {
    const activityRule = {
      entryId: RECHARGE_ACTIVITY_ENTRY_ID,
      switchOn: !!platform.activity.thirdPay,
      payLinkType: Number(platform.activity.payLinkType || 0),
      payMethods: buildRechargePayMethodsPayload(platform.activity.payMethods || []),
      pushRuleIds: Array.isArray(platform.activity.pushRuleIds) ? platform.activity.pushRuleIds : []
    }
    rules.push(activityRule)
  }

  return rules
}

export const buildRechargeTemplatePayload = (param) => ({
  iosRules: buildRechargePlatformRules(param.ios || {}),
  androidRules: buildRechargePlatformRules(param.android || {})
})

export const sanitizeGroupParamByCapability = (code, rawParam) => {
  const capabilityCode = toCapabilityCode(code)
  const param = clone(normalizeGroupParamByCapability(capabilityCode, rawParam))

  if (capabilityCode === '3') {
    return {
      signInAdEnabled: Boolean(param.signInAd && param.signInAd.enabled),
      signInConfig: buildSignInConfigPayload(param.signInAd),
      episodeUnlockAdEnabled: Boolean(param.unlockAd && param.unlockAd.enabled),
      episodeUnlockConfig: buildUnlockConfigPayload(param.unlockAd),
      splashAdEnabled: Boolean(param.splashAd && param.splashAd.enabled),
      splashAdConfig: buildSplashConfigPayload(param.splashAd),
      feedAdEnabled: Boolean(param.feedAd && param.feedAd.enabled),
      feedAdConfig: buildFeedConfigPayload(param.feedAd),
      interstitialAdEnabled: Boolean(param.interstitialAd && param.interstitialAd.enabled),
      interstitialAdConfig: buildInterstitialConfigPayload(param.interstitialAd)
    }
  }

  if (capabilityCode === '7') {
    delete param.memberUiStyle
    delete param.memberPriceText
  }

  if (capabilityCode === '8') {
    delete param.popupName
    delete param.popupRuleName
    delete param.templateRuleId
    delete param.templateRuleName
    delete param.crowdIds
    delete param.crowdLimit
    delete param.status
  }

  if (capabilityCode === '9') {
    return {
      iosRules: (param.iosRules || []).map((item) =>
        buildThirdPayRulePayload(item)
      ),
      androidRules: (param.androidRules || []).map((item) =>
        buildThirdPayRulePayload(item)
      ),
      iosPayMethods: buildThirdPayMethodPayload(param.iosPayMethods),
      androidPayMethods: buildThirdPayMethodPayload(param.androidPayMethods),
      iosPayLinkType: Number(param.iosPayLinkType || 0),
      androidPayLinkType: Number(param.androidPayLinkType || 0)
    }
  }

  if (capabilityCode === '10') {
    return buildRechargeTemplatePayload(param)
  }

  return param
}

export const syncControlGroupParamByCapability = (form) => {
  if (!form || !form.experimentCapability) return
  form.controlGroupParam = createGroupParamByCapability(
    form.experimentCapability
  )
}

export const extractDefaultGroupParam = (data = {}) => {
  const defaultGroup = getControlGroupRecord(data)
  const capabilityCode = toCapabilityCode(data.experimentCapability)

  if (!defaultGroup) {
    return createGroupParamByCapability(capabilityCode)
  }

  return normalizeGroupParamByCapability(
    capabilityCode,
    parseGroupParam(defaultGroup.experimentGroupParam)
  )
}

export const buildExperimentEditorForm = (data = {}) => {
  const capabilityCode = toCapabilityCode(data.experimentCapability)
  const thirdPayCapability = isThirdPayCapability(capabilityCode)
  const controlGroup = getControlGroupRecord(data)
  const groupList = getExperimentGroupRecords(data)

  return {
    ...createExperimentForm(),
    ...data,
    experimentCapability: capabilityCode,
    experimentType:
      data.experimentType === undefined || data.experimentType === null
        ? ''
        : String(data.experimentType),
    deviceSys:
      data.deviceSys === undefined || data.deviceSys === null
        ? ''
        : String(data.deviceSys),
    linkChannel: Array.isArray(data.linkChannel)
      ? data.linkChannel.map((item) => String(item))
      : [],
    countries: Array.isArray(data.countries) ? [...data.countries] : [],
    countriesUnlimited:
      data.countriesUnlimited === undefined || data.countriesUnlimited === null
        ? ''
        : Number(!data.countriesUnlimited),
    playIds: thirdPayCapability
      ? []
      : Array.isArray(data.playIds)
      ? [...data.playIds]
      : [],
    playIdsUnlimited:
      thirdPayCapability
        ? ''
        : data.playIdsUnlimited === undefined || data.playIdsUnlimited === null
        ? ''
        : Number(!data.playIdsUnlimited),
    crowdType:
      data.crowdType === undefined || data.crowdType === null
        ? -1
        : Number(data.crowdType),
    crowdIds: Array.isArray(data.crowdIds) ? [...data.crowdIds] : [],
    crowdCountryCodes: Array.isArray(data.crowdCountryCodes)
      ? [...data.crowdCountryCodes]
      : [],
    crowdOptions: Array.isArray(data.crowdOptions)
      ? [...data.crowdOptions]
      : [],
    crowdMode:
      thirdPayCapability ||
      data.crowdType === 0 ||
      (Array.isArray(data.crowdIds) && data.crowdIds.length)
        ? 'selected'
        : 'all',
    controlGroupId: controlGroup && controlGroup.id ? controlGroup.id : '',
    controlGroupName:
      (controlGroup && controlGroup.experimentGroupName) || '对照组',
    controlGroupParticipateRatio:
      controlGroup &&
      controlGroup.participateRatio !== undefined &&
      controlGroup.participateRatio !== null
        ? Number(controlGroup.participateRatio)
        : 0,
    controlGroupParam: extractDefaultGroupParam(data),
    groups: groupList.map((item) => ({
      ...item,
      experimentGroupParam: normalizeGroupParamByCapability(
        capabilityCode,
        parseGroupParam(item.experimentGroupParam)
      )
    }))
  }
}

export const buildExperimentSubmitData = (form, action) => {
  const capabilityCode = toCapabilityCode(form.experimentCapability)
  const thirdPayCapability = isThirdPayCapability(capabilityCode)
  const experimentGroups = (form.groups || []).map((group, index) => ({
    ...group,
    experimentGroupName: group.experimentGroupName || '实验组' + (index + 1),
    experimentGroupParam: JSON.stringify(
      sanitizeGroupParamByCapability(capabilityCode, group.experimentGroupParam)
    ),
    experimentGroupTag: 0
  }))
  const submitData = {
    ...form,
    experimentCapability: Number(form.experimentCapability),
    experimentType: Number(form.experimentType),
    groups: experimentGroups,
    startNow: action
  }

  if (form.playIdsUnlimited === 0 || form.playIdsUnlimited === 1) {
    submitData.playIdsUnlimited = form.playIdsUnlimited === 0
  }

  if (isLegacyCapability(capabilityCode)) {
    submitData.crowdType = -1
    if (form.countriesUnlimited === 0 || form.countriesUnlimited === 1) {
      submitData.countriesUnlimited = form.countriesUnlimited === 0
    }
    delete submitData.crowdIds
    delete submitData.crowdMode
  } else {
    submitData.groups = isReadonlyControlGroupCapability(capabilityCode)
      ? experimentGroups
      : [
          {
            ...(form.controlGroupId ? { id: form.controlGroupId } : {}),
            experimentGroupName: form.controlGroupName || '对照组',
            experimentGroupParam: JSON.stringify(
              sanitizeGroupParamByCapability(
                capabilityCode,
                form.controlGroupParam
              )
            ),
            experimentGroupTag: 1,
            participateRatio: Number(form.controlGroupParticipateRatio || 0)
          },
          ...experimentGroups
        ]
    submitData.crowdType =
      thirdPayCapability || form.crowdMode === 'selected' ? 0 : -1
    submitData.crowdIds = Array.isArray(form.crowdIds) ? [...form.crowdIds] : []
    delete submitData.deviceSys
    delete submitData.countriesUnlimited
    delete submitData.countries
    delete submitData.linkChannel
    delete submitData.crowdMode
  }

  if (thirdPayCapability) {
    delete submitData.playIdsUnlimited
    delete submitData.playIds
  }

  delete submitData.controlGroupParam
  delete submitData.controlGroupId
  delete submitData.controlGroupName
  delete submitData.controlGroupParticipateRatio
  delete submitData.crowdCountryCodes
  delete submitData.crowdOptions

  return submitData
}

export const buildPushTriggerActionList = (position, options = []) => {
  if (!position) return []

  const allowedValues = []
  const currentPosition = Number(position)

  if ([1, 3, 4, 7].includes(currentPosition)) {
    allowedValues.push(9)
  }
  if (currentPosition === 2) {
    allowedValues.push(5, 6, 7, 10)
  }
  if ([5, 6].includes(currentPosition)) {
    allowedValues.push(10)
  }

  return ensureArray(options).filter((item) =>
    allowedValues.includes(Number(item.dictValue))
  )
}

export const buildAdStrategyTemplatePayload = (data = {}) =>
  normalizeGroupParamByCapability('3', data)

export const buildActivityPushTemplatePayload = (data = {}) =>
  normalizeGroupParamByCapability('8', data)

export const mapAdStrategyFormToPayload = (config = {}) => ({
  signInAdEnabled: Boolean(config.signInAd && config.signInAd.enabled),
  signInConfig: buildSignInConfigPayload(config.signInAd),
  episodeUnlockAdEnabled: Boolean(config.unlockAd && config.unlockAd.enabled),
  episodeUnlockConfig: buildUnlockConfigPayload(config.unlockAd),
  splashAdEnabled: Boolean(config.splashAd && config.splashAd.enabled),
  splashAdConfig: buildSplashConfigPayload(config.splashAd),
  feedAdEnabled: Boolean(config.feedAd && config.feedAd.enabled),
  feedAdConfig: buildFeedConfigPayload(config.feedAd),
  interstitialAdEnabled: Boolean(config.interstitialAd && config.interstitialAd.enabled),
  interstitialAdConfig: buildInterstitialConfigPayload(config.interstitialAd)
})

export const mapLiveAdStrategyToRuntimePayload = (config = {}) =>
  mapAdStrategyFormToPayload(config)
